<!-- 举报方式 -->
<template>
  <div class="report">
    <div class="title">举 报 方 式</div>
    <div class="content">
      <div class="flex">
        <img src="../../assets/images/report_icon_04.webp" alt="" />
        <p>
          <b>来信请寄： </b>
          <span>广西壮族自治区纪委监类驻自治区市场监督管理局纪检监察组</span>
        </p>
      </div>
      <div class="flex">
        <img src="../../assets/images/report_icon_05.webp" alt="" />
        <p><b>邮编：</b><span>530028</span></p>
      </div>
      <div class="flex">
        <img src="../../assets/images/report_icon_03.webp" alt="" />
        <p><b>来访请到：</b><span>南宁市怡宾路1号</span></p>
      </div>
      <div class="flex">
        <img src="../../assets/images/report_icon_02.webp" alt="" />
        <p><b>举报电话：</b><span>(0771)12388</span></p>
      </div
      <div class="flex">
        <img src="../../assets/images/report_icon_01.webp" alt="" />
        <p>
          <b>网上举报：</b>

          <a href="http://guangxi.12388.gov.cn/" target="_blank"
            >http://guangxi.12388.gov.cn/
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {}
}
</script>

<style lang="scss" scope>
.report {
  margin-bottom: 40px;
  .content {
    height: 435px;
    width: 100%;
    background: url(../../assets/images/report_back.webp) no-repeat;
    background-size: 100% 100%;
    padding: 50px 73px;
    .flex {
      margin-bottom: 12px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 11px;
      }
      b {
        display: block;
        line-height: 1;
        margin-bottom: 12px;
        color: #333;
      }
      p {
      }
      a {
        color: #333;
        text-decoration: underline;
        &:hover {
          color: #1b6ad2;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .report {
    .content {
      height: max-content;
      padding: 32px 16px;
      .flex {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
